var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gfu-slider", attrs: { "data-qa": "slider-container" } },
    [
      _c("div", { staticClass: "_flex _jc-sb _ai-c" }, [
        _c("div", [_vm._t("header")], 2),
        _vm._v(" "),
        _vm.displayArrows
          ? _c(
              "div",
              { staticClass: "gfu-slider__controls _as-fs" },
              [
                _c(
                  "base-button",
                  {
                    staticClass: "_ba-0 _mr-1",
                    attrs: {
                      theme: "white",
                      shape: "circle",
                      shadow: "tight",
                      disabled: _vm.displayArrows && !_vm.isOverflownLeft,
                      "aria-label": _vm.Resources.Common.ScrollLeftButtonLabel,
                      "data-qa": "left-arrow-button",
                    },
                    on: { click: _vm.onScrollLeft },
                  },
                  [
                    _c("base-icon", {
                      staticClass: "_tc--accent",
                      attrs: { name: "chevron-left", size: "lg" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "_ba-0",
                    attrs: {
                      theme: "white",
                      shape: "circle",
                      shadow: "tight",
                      "aria-label": _vm.Resources.Common.ScrollRightButtonLabel,
                      disabled: _vm.displayArrows && !_vm.isOverflownRight,
                      "data-qa": "right-arrow-button",
                    },
                    on: { click: _vm.onScrollRight },
                  },
                  [
                    _c("base-icon", {
                      staticClass: "_tc--accent",
                      attrs: { name: "chevron-right", size: "lg" },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: ["gfu-slider__slides-wrapper", _vm.slidesWrapperClass] },
        [
          _c(
            "div",
            {
              ref: "slides",
              class: [
                "gfu-slider__slides",
                {
                  "gfu-slider__slides--negative-margin": _vm.hasNegativeMargin,
                },
                {
                  "gfu-slider__slides--center":
                    _vm.centered && !_vm.isOverflown,
                  "gfu-slider__slides--no-scroll": _vm.preventScroll,
                },
                _vm.slidesClass,
              ],
            },
            [_vm._t("default")],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }